import { v4 as uuidv4 } from "uuid";

import { BaseApiService } from "../base/base-api.service";
import { ListSortDirection, Sort } from "../../models/api/sort";

import { TransactionDocumentDTO, TransactionDocumentSTO } from "../../models/transactions-documents";
import { DocumentDTO } from "../../models/documents/document-dto";
import { SaveResponse } from "../../models/api/save/save.response";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { TransactionRef } from "../../models/transactions";

export class TransactionsDocumentsApiService extends BaseApiService<TransactionDocumentDTO, TransactionDocumentSTO> {
  constructor() {
    super({
      servicePath: "/TransactionsDocuments",
      loadItemsPath: "/GetTransactionsDocuments",
      saveItemsPath: "/SaveTransactionsDocuments",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const saveTransactionDocument = async (
  transaction: TransactionRef,
  document: DocumentDTO,
  correlationId?: string | null,
  notifyOnlyErrors?: boolean
): Promise<SaveResponse> => {
  const transactionDocumentId = transaction.transactionDocuments?.find((doc) => doc.document?.id === document.id);

  const response = await new TransactionsDocumentsApiService().saveItems(
    [
      {
        id: transactionDocumentId?.id ?? uuidv4(),
        document,
        transaction,
        isDeleted: false,
        companyAccount: document.companyAccount ?? transaction.companyAccount,
      },
    ],
    undefined,
    correlationId
  );

  notifyOnlyErrors
    ? toastifyResponse(response, "failed", "failure_saving_document", "error_saving_document")
    : toastifyResponse(
        response,
        "all",
        "success_saving_transaction_document",
        "failure_saving_transaction_document",
        "error_saving_transaction_document"
      );

  return response;
};
